<div class="site-search" :class="rootClasses" @focusout="onFocusOut">
	<form class="site-search__bar" role="search" @submit.prevent="onSubmit">
		<div class="control has-icons-left is-large" :class="{ 'is-loading': isSearching }">
			<input ref="input"
				   class="input is-large"
				   type="search"
				   autocomplete="off"
				   enterkeyhint="search"
				   role="combobox"
				   aria-autocomplete="list"
				   :aria-expanded="showPanel ? 'true' : 'false'"
				   :aria-controls="listId"
				   :placeholder="placeholder"
				   :value="query"
				   @input="onInput"
				   @focus="onFocus"
				   @click="onFocus"
				   @keydown="onKeydown" />
			<span class="icon is-left"><svg-icon icon="search" /></span>
		</div>
		<button v-if="isLayerMode" type="button" class="site-search__close" aria-label="Suche schliessen" @click="close">
			<svg-icon icon="close" />
		</button>
	</form>
	<div v-if="showPanel" class="site-search__panel" :class="{ 'is-searching': isSearching }">
		<div v-if="showChips" class="site-search__chips" role="tablist" @pointerdown.prevent>
			<button type="button"
					class="site-search__chip"
					:class="{ 'is-active': activeType == null }"
					role="tab"
					:aria-selected="activeType == null ? 'true' : 'false'"
					@click="setType(null)">
				Alle ({{ totalFound }})
			</button>
			<button v-for="facet in facets"
					:key="facet.value"
					type="button"
					class="site-search__chip"
					:class="{ 'is-active': activeType === facet.value }"
					role="tab"
					:aria-selected="activeType === facet.value ? 'true' : 'false'"
					@click="setType(facet.value)">
				{{ facet.value }} ({{ facet.count }})
			</button>
		</div>
		<div ref="scroller" class="site-search__scroller">
			<ul v-if="hasResults" :id="listId" class="site-search__list" role="listbox">
				<li v-for="(item, index) in items"
					:key="item.url ?? index"
					class="site-search__result"
					:class="{ 'is-highlighted': index === highlightedIndex }"
					role="option"
					:aria-selected="index === highlightedIndex ? 'true' : 'false'">
					<a class="site-search__result-link"
					   :href="item.url ?? '#'"
					   :target="newTab ? '_blank' : null"
					   :rel="newTab ? 'noopener' : null"
					   @click="onResultClick($event, item)"
					   @pointermove="highlightedIndex = index">
						<div class="site-search__result-media">
							<img v-if="item.imageUrl" class="site-search__result-image" :src="item.imageUrl" alt="" loading="lazy" />
							<span v-else class="site-search__result-icon"><svg-icon :icon="iconFor(item.docType)" /></span>
							<span v-if="showTypes" class="site-search__result-type">{{ item.docType }}</span>
						</div>
						<div class="site-search__result-body">
							<span class="title site-search__result-title">{{ item.title }}</span>
							<p v-if="item.snippet" class="site-search__result-snippet">{{ item.snippet }}</p>
						</div>
					</a>
				</li>
			</ul>
			<div v-if="hasResults && hasMore" class="site-search__more">
				<button type="button" class="button is-primary" :class="{ 'is-loading': isLoading }" @pointerdown.prevent @click="loadMore">
					Weitere Resultate
				</button>
			</div>
			<div v-if="!hasResults && hasQuery" class="site-search__status">
				<span v-if="isSearching">Suche …</span>
				<span v-else-if="hasSearched">Keine Resultate gefunden.</span>
			</div>
			<p v-if="showHint" class="site-search__hint">{{ hint }}</p>
		</div>
	</div>
</div>
